<template>
  <Modal v-model="publishingPlatformModal" footer-hide width="728" :title="$t('key1001294')">
    <div class="publishingPlatform_box">
      <div class="publishingPlatform_box_item" v-for="item in publishingPlatformList" @click="selectPublishingPlatform(item)">
        <img :src="item.logoPath" width="107" height="42" alt="" :onerror="errorPlaceholder">
        <span class="mt8">{{ item.platformName === 'ebay' ? item.platformId : item.platformName }}</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getEnabledPlatforms, pageJump, commonLocalStorage} from "@/utils/common";

export default {
  name: "publishingPlatformModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      publishingPlatformModal: false,
      publishingPlatformList: [],
      errorPlaceholder: "this.onerror='';this.classList.add('error-image'); this.src='" + require('@/assets/images/imageError.jpg') + "'",
      aliexpressChoiceLogoPath: require('@/assets/images/platform/aliexpressChoice.png'),
      temuChoiceLogoPath: require('@/assets/images/platform/temu_choice.png'),
      ymsProductId: null
    };
  },
  methods: {
    // 初始化数据
    initPublishingPlatformData(data, ymsProductCategoryId, source) {
      let v = this;
      // 跨境电商平台配置
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? v.$store.state.configurationItemInfo;
      let distributorPlatformSet =  obj?.distributorPlatformSet || [];
      if (data && data.length > 0) {
        let newList = [];
        let newData = [];
        if (source === 'listing') {
          data.map((item) => {
            let obj = {
              platformId: item,
              platformName: item !== 'eBay' ? item.charAt(0).toUpperCase() + item.slice(1) : item
            };
            newData.push(obj);
          });
        } else {
          newData = JSON.parse(JSON.stringify(data));
        }
        getEnabledPlatforms([], ymsProductCategoryId).then((list) => {
          newData.map((ele) => {
            // 速卖通全托管平台
            if (ele.platformId === 'aliexpress') {
              let obj = {
                platformName: 'AliexpressChoice',
                platformId: 'aliexpressChoice',
                logoPath: v.aliexpressChoiceLogoPath,
              };
              newList.push(obj);
            }
            list.map((item) => {
              if (source === 'listing' && ele.platformId === item.platformId) {
                ele.platformName = item.name;
              }
              if (ele.platformId === item.platformId || ele.platformName === item.name || ele.platformName === item.platformId) {
                // Temu半托管平台
                if (ele.platformId === 'temu_choice') {
                  ele.logoPath = v.temuChoiceLogoPath;
                } else {
                  ele.logoPath = item.logoPath;
                }
              }
            });
          });
          if (distributorPlatformSet.length > 0) {
            let platformList = newData.filter(item => distributorPlatformSet.includes(item.platformId));
            v.publishingPlatformList = [...platformList, ...newList];
          } else {
            v.publishingPlatformList = [];
          }
          if (v.publishingPlatformList.length > 0) {
            v.publishingPlatformModal = true;
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001290'));
            v.publishingPlatformModal = false;
            return false;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001291'));
        return false;
      }
      v.publishingPlatformModal = true;
    },
    // 选择刊登的平台
    selectPublishingPlatform(item) {
      // 判断当前平台是否有绑定店铺
      let v = this;
      let query = {
        platformId: item.platformId,
        status: 1 // 1'‑启用 '0'‑停用
      };
      v.axios.post(api.post_ymsDistributorProductInfo_querySaleAccountInfoListByPlatform, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            v.$emit('changePlatform', {itemObj: item, storeData: data});
          } else {
            v.$Modal.warning({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001292'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001293'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000389'),
              onOk: () => {
                pageJump('/distributor.html#/platformStoreList', '/yms-distributor-service', '_blank');
              }
            });
          }
          v.publishingPlatformModal = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.publishingPlatform_box {
  display: flex;
  flex-wrap: wrap;
  max-height: 600px;

  .publishingPlatform_box_item {
    width: 107px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 16px 16px;
    cursor: pointer;

    img {
      border: 1px solid #E1E1E1;
      box-sizing: border-box;
      border-radius: 5px;
      overflow: hidden;
    }
  }
}
</style>